import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ChangeEmailPopupComponent } from './components/change-email-popup/change-email-popup.component';
import { ChangePasswordSuccessPopupComponent } from './components/change-password-success-popup/change-password-success-popup.component';
import { MyAccountApiService } from './my-account-api.service';
import { MyAccountEffects } from './my-account.effects';
import { myAccountInitialState, myAccountReducer } from './my-account.reducer';

@NgModule({
  declarations: [
    ChangePasswordSuccessPopupComponent,
    ChangeEmailPopupComponent
  ],
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule,
    StoreModule.forFeature('myAccount', myAccountReducer, {
      initialState: myAccountInitialState
    }),
    EffectsModule.forFeature([MyAccountEffects]),
    TranslateModule,
    ReactiveFormsModule
  ],
  providers: [MyAccountApiService, provideHttpClient(withInterceptorsFromDi())]
})
export class MyAccountStoreModule {}
